import axios from 'axios'
import { env } from './../config'

export async function sendContact(data) {
    return axios.post(`${env.BASE_URL}/send`, data)
}